fragment PolicyReviewFields on PolicyReview {
  id
  reviewedOn
  outcome
  version
  note
  recordedByName
  createdAt
}
